import React, { useState } from "react";
import { Button, Dialog } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CreateWithIAModal from "./CreateWithIAModal";

const CreateWithIAButton = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        onClick={handleOpen}
        startIcon={<AutoAwesomeIcon />}
        sx={{
          fontWeight: "bold",
          textTransform: "none",
        }}
        data-tour="crear-con-ia"
      >
        Crear con IA
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <CreateWithIAModal onClose={handleClose} />
      </Dialog>
    </>
  );
};

export default CreateWithIAButton;
